module.exports = __webpack_public_path__ + "img/week_list_title.1c910cd6.png";